import Instance from "../../utils/apiNip";
import responseHandler from "../../utils/responseHandler";
import Storage from "../../utils/storage";
import UserActions from "../Types";

export const getApiHistoryStart = () => ({
  type: UserActions.GET_API_HISTORY_START,
});

export const getApiHistorySuccess = (payload) => ({
  type: UserActions.GET_API_HISTORY_SUCCESS,
  payload,
});

export const getApiHistoryFailure = (payload) => ({
  type: UserActions.GET_API_HISTORY_FAILURE,
  payload,
});

export const filterDateApiHistoryStart = () => ({
  type: UserActions.FILTER_DATE_APIHISTORY_START,
});

export const filterDateApiHistorySuccess = (payload) => ({
  type: UserActions.FILTER_DATE_APIHISTORY_SUCCESS,
  payload,
});

export const filterDateApiHistoryFailure = (payload) => ({
  type: UserActions.FILTER_DATE_APIHISTORY_FAILURE,
  payload,
});

export const filterStatusApiHistoryStart = () => ({
  type: UserActions.FILTER_STATUS_APIHISTORY_START,
});

export const filterStatusApiHistorySuccess = (payload) => ({
  type: UserActions.FILTER_STATUS_APIHISTORY_SUCCESS,
  payload,
});

export const filterStatusApiHistoryFailure = (payload) => ({
  type: UserActions.FILTER_STATUS_APIHISTORY_FAILURE,
  payload,
});

export const getAllApiHistory = (limit, offset) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(getApiHistoryStart());
  API.get(
    `sandbox/integration/outward/user-api-history?limit=${limit}&offset=${offset}`
  ).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getApiHistorySuccess(data.data));
    } else {
      dispatch(getApiHistoryFailure(data));
    }
  });
};

export const filterDateApiHistory = (
  limit,
  offset,
  start_date,
  end_date
) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(filterDateApiHistoryStart());
  API.get(
    `sandbox/integration/outward/user-api-history?limit=${limit}&offset=${offset}&start_date=${start_date}&end_date=${end_date}`
  ).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(filterDateApiHistorySuccess(data.data));
    } else {
      dispatch(filterDateApiHistoryFailure(data));
    }
  });
};

export const filterStatusApiHistory = (limit, offset, type) => async (
  dispatch
) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(filterStatusApiHistoryStart());
  API.get(
    `sandbox/integration/outward/user-api-history?limit=${limit}&offset=${offset}&type=${type}`
  ).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(filterStatusApiHistorySuccess(data.data));
    } else {
      dispatch(filterStatusApiHistoryFailure(data));
    }
  });
};
